// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app .qrcode[data-v-312fa798]{width:7.5rem}", ""]);
// Exports
module.exports = exports;
